import React, { PropTypes } from 'react';
import { Jumbotron, Button, Row, FormGroup, FormControl, Col } from 'react-bootstrap';
import { Column, Table } from 'react-virtualized';
import _ from 'lodash';

import { gettext } from '../../../i18n/service.js';
import getCurLang from '../../../businessLogic/getCurLang.js';
import BillingDetailComponent from './BillingDetailComponent.js';

export default class BillingComponent extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.createNewCard = false;
    this.billings = [];

    this.state = {
      detailbill: null,
      selectedWeek: null,
      selectedRow: null,
      workingWeeks: []
    };

    this.props.getBills();
    _.bindAll(this, ['submit', 'renderBillingForm', 'payBill', 'setOrderToDetail']);
  }

  componentWillMount() {
    this.props.getCards(this.props.account.id);
  }

  componentWillReceiveProps(nextProps) {
    if (this.needUpdateDetails && nextProps.bills && this.state.detailbill) {
      const { billings } = nextProps.bills;
      if (billings && billings.length) {
        this.state.detailbill = billings.find(bill => this.state.detailbill.id === bill.id);
        this.needUpdateDetails = false;
        this.props.endSpinner();
      }
    }
  }

  submit(e) {
    e.preventDefault();
    e.stopPropagation();
    const elems = Array.from(e.target.elements);
    let fields = elems.reduce((prev, curr) => {
      if (!curr.name) {
        return prev;
      }
      return prev;
    }, {});
    return true;
    this.props.onSubmit(values);
  }

  renderBillingForm() {
    return (
      <Jumbotron>
        <Row>
          <Col sm={6}>
            <h6><span>{gettext('TOTAL-PROCESSED-ORDERS') + ':'}</span></h6>
            <h6><span>{gettext('TOTAL-PICKUP-POINTS') + ':'}</span></h6>
            <h6><span>{gettext('DELIVERED-ORDERS') + ':'}</span></h6>
            <h6><span>{gettext('RETURNED-ORDERS') + ':'}</span></h6>
            <h6><span>{gettext('AVERAGE-ORDER-COST') + ':'}</span></h6>
          </Col>
          <Col sm={6}>
            <h6><span>1</span></h6>
            <h6><span>1</span></h6>
            <h6><span>1</span></h6>
            <h6><span>1</span></h6>
            <h6><span>1</span></h6>
          </Col>
        </Row>
      </Jumbotron>
    );
  }

  getWeekNumber(billing) {
    const keys = ['ww01', 'ww02', 'ww03', 'ww04', 'ww05', 'ww06'];
    let count = 0;
    let workingWeeks = [];
    for (let key of keys) {
      if (billing[key].startTime && billing[key].startTime) {
        count++;
        const temp = {
          key: key,
          value: billing[key]
        };
        workingWeeks.push(temp);
      }
    }
    this.setState({ workingWeeks: workingWeeks });
    return count;
  }

  setOrderToDetail(row) {
    this.setState({ selectedRow: row.rowData });
    this.billings.map(billing => {
      if (billing.id == row.rowData.id) {
        const selectedWeek = this.getWeekNumber(billing);
        this.setState({ detailbill: billing, selectedWeek: selectedWeek });
      }
    });
  }

  payBill(billId, card) {
    this.props.startSpinner();
    this.props.payBill(billId, card);
    this.needUpdateDetails = true;
  }

  render() {
    const bills = this.props.bills;
    if (bills && bills.billings.length > 0) {
      this.billings = _.filter(bills.billings, (billing) => {
        return (billing.ww01 && billing.ww01.startTime);
      });

      if (this.billingFilters)
        this.billings = _.filter(this.billings, (billing) => {
          return ((billing.month && billing.status) &&
            (String(billing.year).indexOf(this.billingFilters) != -1
              || String(billing.cost).indexOf(this.billingFilters) != -1
              || billing.month.toUpperCase().indexOf(String(this.billingFilters).toUpperCase()) != -1
              || billing.status.toUpperCase().indexOf(String(this.billingFilters).toUpperCase()) != -1));
        });

      return (
        <div className="dispatcher_profile billing-page">
          <Jumbotron>
            <div className="item_head_title">
              <h3>{gettext('BILLING')}</h3>
            </div>
            <Row className="center_flex display_none">
              <Col sm={8}>
                <div>
                  <div className="multi_select">
                    <FormGroup controlId="formControlsSelectMultiple">
                      <FormControl componentClass="select" multiple />
                    </FormGroup>
                  </div>
                  <div className="milti_controls">
                    <Button className="multi_btn margin_bottom_halfem">+</Button>
                    <Button className="multi_btn margin_bottom_halfem">-</Button>
                  </div>
                </div>

              </Col>
            </Row>
            <Row className="center_flex">
              <Col sm={10}>
                <Col sm={12}>
                  <FormControl
                    type="text"
                    className="billing-filter"
                    placeholder={gettext('SEARCH')}
                    onChange={(e) => {
                      this.billingFilters = e.target.value;
                      this.forceUpdate();
                    }} />
                  <div className="table_container">
                    <Table
                      width={300}
                      height={300}
                      headerHeight={20}
                      rowHeight={30}
                      rowCount={this.billings.length}
                      rowGetter={({ index }) => this.billings[index]}
                      rowClassName={({ index }) =>
                        this.state.selectedRow && this.billings[index] &&
                        this.billings[index].id == this.state.selectedRow.id ? 'active' : ''
                      }
                      onRowClick={(e) => {
                        this.setOrderToDetail(e);
                      }}
                    >
                      <Column
                        label={gettext('MONTH')}
                        dataKey="month"
                        width={500}
                      />
                      <Column
                        width={500}
                        label={gettext('YEAR')}
                        dataKey="year"
                      />
                      <Column
                        width={500}
                        label={gettext('COST')}
                        dataKey="cost"
                      />
                      <Column
                        width={500}
                        label={gettext('STATUS')}
                        dataKey="status"
                      />
                    </Table>
                  </div>
                </Col>
              </Col>
            </Row>
          </Jumbotron>
          {this.state.detailbill ? <BillingDetailComponent
            router={this.props.router}
            selectedWeek={this.state.selectedWeek}
            detailbill={this.state.detailbill}
            payBill={this.payBill}
            showMessage={this.props.showMessage}
            workingWeeks={this.state.workingWeeks} /> : ''}
        </div>
      );
    } else
      return null;
  }
}

BillingComponent.propTypes = {
  orders: PropTypes.array
};



// WEBPACK FOOTER //
// ./src/components/settings/components/BillingComponent.js